import React from 'react';
import styled from 'styled-components';
import { PaymentFormProps } from './CreditCardForm';
import { User } from '../../../../../LoginModal/routes';
import { Address } from '../../../../../LoginModal/pages/Address';
import { Wallet } from '../../../../../../providers/DonorProvider/interfaces';
import { useAddCardLogic } from './useAddCardLogic';
import { AddCardExtraComponent } from './AddressCompleteForm';

const StyledAddress = styled(Address)`
  padding-top: 18px;
`;

const AddressForm: React.FC<
  PaymentFormProps & {
    addCard: (card: Wallet) => unknown;
    handlePaymentModalClose: () => unknown;
  }
> = ({ user, setUser, setRoute, addCard, handlePaymentModalClose }) => {
  const { requestState, handleSubmit } = useAddCardLogic({
    eventName: 'Address',
    user,
    addCard,
    setRoute,
    setUser,
    handlePaymentModalClose
  });

  const handleNext = (user: User) => {
    setUser(user);
    setRoute('ADDRESS_COMPLETE');
  };

  const button: {
    buttonText: string;
    isLoading: boolean;
    ExtraComponent: React.FC | undefined;
    onClick: (user: User) => unknown;
  } =
    user.address?.city && user.address.state
      ? {
          buttonText: 'Add card',
          isLoading: requestState.type === 'REQUEST_START',
          onClick: handleSubmit,
          ExtraComponent: () => (
            <AddCardExtraComponent requestState={requestState} />
          )
        }
      : {
          buttonText: 'Next',
          isLoading: false,
          onClick: handleNext,
          ExtraComponent: undefined
        };

  return (
    <StyledAddress
      user={user}
      page={'ADDRESS'}
      closeModal={() => null}
      onNext={button.onClick}
      isLoading={button.isLoading}
      buttonText={button.buttonText}
      ExtraComponent={button.ExtraComponent}
      questionText={'What’s your billing address?'}
    />
  );
};

export default AddressForm;
